import request from '@/utils/request'

// 获取将康评分
export function fetchScore(query) {
  return request({
    url: '/api/v1/user/health/score/record',
    method: 'get',
    params: query
  })
}

// 获取各个健康数据最新一条数据
export function fetchHealth(query) {
  return request({
    url: '/api/v1/healthdatafirst',
    method: 'get',
    params: query
  })
}

// 获取各个健康数据最新一条数据
export function fetchHealthFirst(query) {
  return request({
    url: '/api/v1/healthdataNewestOne',
    method: 'get',
    params: query
  })
}

// 获取某时间段每天最新一条数据接口
export function fetchHealths(query) {
  return request({
    url: '/api/v1/healthdataofstartendtime',
    method: 'get',
    params: query
  })
}

// 健康建议
export function fetchSuggest(query) {
  return request({
    url: '/api/v1/healthadvice/page',
    method: 'get',
    params: query
  })
}

// 修改已读
export function updateRead(data) {
  return request({
    url: `/api/v1/healthadvice/read?accountId=${data.accountId}`,
    method: 'post',
    data
  })
}
// 查询健康建议未读条数
export function getReadCnt(query) {
  return request({
    url: '/api/v1/healthadvice/readCnt',
    method: 'get',
    params: query
  })
}

// 健康预警
export function fetchWarning(query) {
  return request({
    url: '/api/v1/heathwarning/page',
    method: 'get',
    params: query
  })
}
// 健康报告列表
export function fetchReports(query) {
  return request({
    url: '/api/v1/healthreport/page',
    method: 'get',
    params: query
  })
}

// 健康报告详情
export function fetchReport(query) {
  return request({
    url: '/api/v2/healthreportdata',
    method: 'get',
    params: query
  })
}

// 血压列表
export function fetchBp(query) {
  return request({
    url: '/api/v1/bloodpressure/page',
    method: 'get',
    params: query
  })
}
// 血压录入
export function postBp(data) {
  return request({
    url: '/api/v1/bloodpressure',
    method: 'post',
    data
  })
}

// 血糖列表
export function fetchBs(query) {
  return request({
    url: '/api/v1/bloodsugar/page',
    method: 'get',
    params: query
  })
}
// 血糖录入
export function postBs(data) {
  return request({
    url: '/api/v1/bloodsugar',
    method: 'post',
    data
  })
}

// 心率列表
export function fetchHb(query) {
  return request({
    url: '/api/v1/heartbeat/page',
    method: 'get',
    params: query
  })
}

// 心率录入
export function postHb(data) {
  return request({
    url: '/api/v1/heartbeat',
    method: 'post',
    data
  })
}

// 血氧列表
export function fetchBo(query) {
  return request({
    url: '/api/v2/bo/static/all/list',
    method: 'get',
    params: query
  })
}
// 血氧录入
export function postBo(data) {
  return request({
    url: '/api/v1/bloodoxygen',
    method: 'post',
    data
  })
}

// 步数列表
export function fetchStep(query) {
  return request({
    url: '/api/v1/walkstep/page',
    method: 'get',
    params: query
  })
}
// 步数录入
export function postStep(data) {
  return request({
    url: '/api/v1/walkstep',
    method: 'post',
    data
  })
}

// 获取呼吸暂停分页数据接口
export function fetchPause(query) {
  return request({
    url: '/api/v1/breathpause/page',
    method: 'get',
    params: query
  })
}
// 呼吸暂停录入
export function postPause(data) {
  return request({
    url: '/api/v1/breathpause',
    method: 'post',
    data
  })
}

// 获取hrv分页数据接口
export function fetchHRV(query) {
  return request({
    url: '/api/v1/hrv/page',
    method: 'get',
    params: query
  })
}
// hrv录入
export function postHRV(data) {
  return request({
    url: '/api/v1/hrv',
    method: 'post',
    data
  })
}

// 获取动脉硬化分页数据接口
export function fetchArtery(query) {
  return request({
    url: '/api/v1/arteriosclerosis/page',
    method: 'get',
    params: query
  })
}
// 动脉硬化录入
export function postArtery(data) {
  return request({
    url: '/api/v1/arteriosclerosis',
    method: 'post',
    data
  })
}

// 获取心脏负荷分页数据接口
export function fetchHeartload(query) {
  return request({
    url: '/api/v1/heartload/page',
    method: 'get',
    params: query
  })
}

// 获取动脉硬化分页数据接口
export function getArteriosclerosisByPage(query) {
  return request({
    url: '/api/v1/arteriosclerosis/page',
    method: 'get',
    params: query
  })
}
// 心脏负荷录入
export function postHeartload(data) {
  return request({
    url: '/api/v1/heartload',
    method: 'post',
    data
  })
}

// 获取普通心电分页数据接口
export function fetchEcg(query) {
  return request({
    url: '/api/v1/heartstate/page',
    method: 'get',
    params: query
  })
}

// 获取专业心电分页数据接口
export function fetchMajorEcg(query) {
  return request({
    url: '/api/v1/ecg/page',
    method: 'get',
    params: query
  })
}

// 心电录入
export function postEcg(data) {
  return request({
    url: '/api/v1/ecg',
    method: 'post',
    data
  })
}

// 获取BMI数据接口
export function fetchBMI(query) {
  return request({
    url: '/api/v1/BMI/page',
    method: 'get',
    params: query
  })
}
// 心电录入
export function postBMI(data) {
  return request({
    url: '/api/v1/BMI',
    method: 'post',
    data
  })
}

// measure [通用接口]
export function fetchMeasure(query, urls) {
  return request({
    url: urls,
    method: 'get',
    params: query
  })
}

// 获取脏音数据接口
export function fetchStetho(query) {
  return request({
    url: '/api/v1/heathstetho/page',
    method: 'get',
    params: query
  })
}

// 查询用户最新的分数计算项详情
export function fetchScoreDetalis(query) {
  return request({
    url: '/api/v1/user/item/details',
    method: 'get',
    params: query
  })
}

// 获取健康评分(新接口)
export function fetchScoreNew(query) {
  return request({
    url: '/api/v1/user/health/score',
    method: 'get',
    params: query
  })
}

// 获取用户是否可以问卷调查
export function fetchScoreQuestion(query) {
  return request({
    baseURL: 'other',
    url: '/api/v1/check/week/have/commit',
    method: 'get',
    params: query
  })
}
// sixecg
export function fetchsixHb(query) {
  return request({
    url: '/api/v2/heartstate/page',
    method: 'get',
    params: query
  })
}
